export const STAKE_TRANSACTION_TYPE = {
  STAKE: 'stake',
  RESTAKE: 'restake',
}
